import styled from "styled-components";

const ImageContainer = styled.div`
  width: 40px;
  margin-right: 15px;
  font-size: 25px;
  opacity: 0.5;

  @media (max-width: 1599px) {
    width: 30px;
    margin-right: 10px;
  }

  @media (max-width :991px){
    width: 100%;
    margin: 0 auto;
    height: 45px;
  } 
  @media (max-width: 575px) {
    width: 100%;
    margin: 0 auto;
  }
`;
export default ImageContainer;
